import React, { useCallback, useEffect, useState } from 'react';
import { Button, CloseIcon, Input } from 'components';
import { t } from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import {
  MobileOtp,
  ResetPasswordApi,
  SendMailOtp,
  VerifyOtpResetPassword,
} from 'redux/features/LoginSlice';
import { useNavigate } from 'react-router-dom';
import { IconButton, InputAdornment } from '@mui/material';
import { Notification } from 'components/CustomNotification';

import { ReactComponent as Visibility } from 'assert/images/Common/visibility.svg';
import { ReactComponent as VisibilityOff } from 'assert/images/Common/visibilityOff.svg';
import { ReactComponent as Exclamation } from 'assert/images/Common/exclamation.svg';

const PasswordVerification = ({ handleChangeToPassword }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authActionsData } = useSelector((state) => state?.LoginReducer);
  const { email, phcode, type } = authActionsData;

  const [seconds, setSeconds] = useState(0);
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(null);
  const [newPasswordShow, setNewPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [loginDetails, setLoginDetails] = useState({
    otp: '',
    password: '',
    confirmpassword: '',
    sid: '',
    pid: '',
  });
  const [errMsg, setErrmsg] = useState({
    password: '',
    confirmpassword: '',
  });

  const handleChange = (data, name) => {
    if(name === 'otp') {
      if (data.length > 6) {
        data = data.slice(0, 6);
      }
    }
    setLoginDetails((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  };

  const handleValidation = () => {
    const validationParams = { ...errMsg };

    if (isConfirmPassword && loginDetails.password.length < 6) {
      validationParams.password = t('Auth.passwordsix');
    } else validationParams.password = '';

    if (
      loginDetails.password?.trim() !== loginDetails.confirmpassword?.trim()
    ) {
      validationParams.confirmpassword = t('Auth.confirmnotmatch');
    } else if (
      isConfirmPassword &&
      loginDetails.confirmpassword?.trim()?.length < 6
    ) {
      validationParams.confirmpassword = t('Auth.confrimsix');
    } else {
      validationParams.confirmpassword = '';
    }

    setErrmsg(validationParams);
  };

  const handleSubmit = useCallback(() => {
    handleValidation();
    setEnableSubmit(!enableSubmit);
  }, [enableSubmit, handleValidation]);

  useEffect(() => {
    if (enableSubmit !== null) {
      const validation = Object.keys(errMsg).every((it) => errMsg[it] === '');
      if (validation) {
        setIsLoading(true);
        if (isConfirmPassword) {
          dispatch(ResetPasswordApi(authActionsData, loginDetails))
            .then((response) => {
              setIsLoading(false);
              navigate('/login');
              Notification('success', response?.data?.message);
            })
            .catch((err) => {
              setIsLoading(false);
              Notification('error', err.response?.data?.message);
            });
        } else {
          dispatch(VerifyOtpResetPassword(authActionsData, loginDetails))
            .then((response) => {
              setIsLoading(false);
              setIsConfirmPassword(!isConfirmPassword);
              Notification('success', response?.data?.message);
            })
            .catch((err) => {
              setIsLoading(false);
              Notification('error', err.response?.data?.message);
            });
        }
      }
    }
  }, [enableSubmit]);

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);

  const SendAgainOtp = () => {
    setSeconds(30);
    if (authActionsData?.type === 'mobile') {
      dispatch(MobileOtp(authActionsData, false, true));
    } else {
      dispatch(SendMailOtp(authActionsData, false, true));
    }
  };

  const isFormValid = () => {
    const { otp, password, confirmpassword } = loginDetails;
    if (isConfirmPassword) {
      return password && confirmpassword;
    } else {
      return otp.length === 6;
    }
  };

  return (
    <>
      <div className="card-title">
        <CloseIcon
          iconType="back"
          customStyle="back_btn"
          onClick={() => handleChangeToPassword(false)}
        />
        {t('Auth.ResetPassword')}
      </div>
      {!isConfirmPassword ? (
        <div className="helper-title">
          {t('Auth.SentCode')} <br /> {t('Auth.VerifyCode')}{' '}
          {type === 'email' ? email : phcode}
        </div>
      ) : (
        <div className="helper-title">{t('Auth.CreatePassword')}</div>
      )}
      {!isConfirmPassword && (
        <div className="otp-field">
          <Input type={"number"} maxLimit={6} value={loginDetails.otp} onChange={(data) => handleChange(data, "otp")} />
        </div>
      )}
      {!isConfirmPassword ? (
        <div className="otp-resend">
          <span>{t('Auth.DontReceive')}</span>
          {seconds === 0 ? (
            <a onClick={SendAgainOtp}>{t('Auth.SendAgain')}</a>
          ) : (
            <div>{seconds}s</div>
          )}
        </div>
      ) : (
        <div className="password-field-container">
          <Input
            label={t('Auth.NewPassword')}
            type={newPasswordShow ? 'text' : 'password'}
            value={loginDetails.password}
            onChange={(data) => handleChange(data, 'password')}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setNewPasswordShow(!newPasswordShow)}
                  edge="end"
                >
                  {newPasswordShow ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          {errMsg.password && (
            <span className="errMsg">
              <Exclamation />
              {errMsg.password}
            </span>
          )}
          <Input
            label={t('Auth.ConfirmPassword')}
            type={confirmPasswordShow ? 'text' : 'password'}
            value={loginDetails.confirmpassword}
            onChange={(data) => handleChange(data, 'confirmpassword')}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
                  edge="end"
                >
                  {confirmPasswordShow ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          {errMsg.confirmpassword && (
            <span className="errMsg">
              <Exclamation />
              {errMsg.confirmpassword}
            </span>
          )}
        </div>
      )}
      {!isConfirmPassword ? (
        <Button
          label={t('Auth.Submit')}
          disabled={!isFormValid()}
          onClick={isFormValid() ? handleSubmit : () => {}}
          customStyles="auth-action-btn"
          loading={isLoading}
          loadingIndicator="Loading…"
        />
      ) : (
        <Button
          label={t('Auth.Reset')}
          disabled={!isFormValid()}
          onClick={isFormValid() ? handleSubmit : () => {}}
          customStyles="auth-action-btn"
          loading={isLoading}
          loadingIndicator="Loading…"
        />
      )}
    </>
  );
};

export default PasswordVerification;
